import { createContext } from "react";

export const ArticulosPresentacionesContext = createContext()
export const ArticulosPresentacionesFormContext = createContext()
export const ArticulosPresentacionesReportContext = createContext()